<app-container class="hidden md:flex" expand>
    <div class="flex flex-col gap-6">
        <ng-container *ngTemplateOutlet="content" />
    </div>
</app-container>

<section class="w-screen h-screen md:hidden">
    <div class="flex flex-col items-start w-full overflow-hidden overflow-y-scroll">
        <div class="fixed flex z-[9999] items-center justify-between w-full p-4 bg-white select-none">
            <lepi-icon (click)="back()" name="material-symbols:arrow-back-ios" class="bg-gray-700 cursor-pointer size-5" />
        </div>
        <ng-container *ngTemplateOutlet="content" />
    </div>
</section>

<ng-template #content>
    <div class="flex flex-col h-full items-center justify-center w-full gap-4 md:gap-8 pt-[56px] md:pt-0 md:px-0 px-4">
        <div class="flex flex-col items-center gap-3">
            <p class="text-gray-800 font-extrabold md:text-[28px] text-2xl">회원가입</p>
            <p class="text-sm text-center text-gray-500">회원가입을 위해 정보를 입력해주세요.</p>
        </div>
        <form [formGroup]="form" class="flex flex-col items-center w-full gap-4 md:gap-8" (ngSubmit)="submit()">
            <div class="flex flex-col items-center w-full gap-3">
                <div class="flex flex-col max-w-[400px] w-full">
                    <app-input-id required label="아이디" formControlName="userId" debounce="300" placeholder="아이디를 입력해주세요" />
                </div>
                <div class="flex flex-col max-w-[400px] w-full">
                    <div class="flex flex-col w-full gap-3">
                        <app-input-password label="비밀번호" formControlName="password" placeholder="비밀번호를 입력해주세요" />
                        <app-input-password label="비밀번호 확인" formControlName="passwordCheck" placeholder="비밀번호를 입력해주세요" />
                    </div>
                    @if (form.hasError('passwordMismatch')) {
                        <div class="text-sm text-red-500">비밀번호가 일치하지 않습니다.</div>
                    }
                </div>
                <div class="flex flex-col max-w-[400px] w-full">
                    <app-input-name required label="이름" formControlName="name" placeholder="이름을 입력해주세요." />
                </div>
                <div class="flex flex-col max-w-[400px] w-full">
                    <app-input-tel
                        required
                        label="연락처"
                        formControlName="tel"
                        placeholder="(예시)01012341234"
                        [max]="11"
                        class="w-full"
                        verify
                    />
                </div>
                <div class="flex flex-col max-w-[400px] w-full">
                    <div class="flex flex-col">
                        <p class="text-sm break-keep">생년월일<span class="text-primary">*</span></p>
                        <lepi-date-picker required formControlName="birthDay" class="w-full" />
                    </div>
                </div>
            </div>
            <div class="flex flex-col items-center w-full max-w-[400px] gap-4 p-4 border border-gray-100 rounded-2xl">
                <div class="flex flex-col gap-2">
                    <p class="font-bold text-gray-800">서비스 이용을 위한 동의 안내</p>
                    <p class="text-sm text-gray-500">서비스 이용에 꼭 필요한 사항입니다. 정책 및 약관 내용을 모두 확인해주세요.</p>
                </div>
                <div class="flex flex-col">
                    <div
                        class="flex items-center w-full gap-3 p-3 border border-gray-200 cursor-pointer rounded-xl"
                        (click)="toggleAllTerms()"
                    >
                        <div class="flex items-center justify-center transition-colors border border-gray-300 rounded-md size-5">
                            <lepi-icon name="ic:baseline-check" class="size-4" [ngClass]="allTermsAgreed() ? 'bg-primary' : 'bg-white'" />
                        </div>
                        <p class="text-gray-800">모두 동의합니다</p>
                    </div>
                    <div class="flex items-center justify-between w-full p-3">
                        <div class="flex items-center w-full gap-1 cursor-pointer" (click)="info.set(!info())">
                            <lepi-icon name="ic:baseline-check" class="size-4" [ngClass]="info() ? 'bg-primary' : 'bg-gray-300'" />
                            <p class="text-sm font-semibold text-gray-500">(필수) 서비스 이용약관에 동의합니다.</p>
                        </div>
                        <lepi-icon
                            (click)="handleDetail(getKeyByValue(termType, termType.USE))"
                            name="material-symbols:arrow-forward-ios"
                            class="block bg-gray-500 cursor-pointer size-3.5"
                        />
                    </div>

                    <div class="flex items-center justify-between w-full p-3">
                        <div class="flex items-center w-full gap-1 cursor-pointer" (click)="service.set(!service())">
                            <lepi-icon name="ic:baseline-check" class="size-4" [ngClass]="service() ? 'bg-primary' : 'bg-gray-300'" />
                            <p class="text-sm font-semibold text-gray-500">(필수) 개인정보 수집/이용에 동의합니다</p>
                        </div>
                        <lepi-icon
                            (click)="handleDetail(getKeyByValue(termType, termType.PRIVACY))"
                            name="material-symbols:arrow-forward-ios"
                            class="block bg-gray-500 cursor-pointer size-3.5"
                        />
                    </div>

                    <div class="flex items-center justify-between w-full p-3">
                        <div class="flex items-start w-full gap-1 cursor-pointer" (click)="marketing.set(!marketing())">
                            <lepi-icon
                                name="ic:baseline-check"
                                class="size-4 shrink-0"
                                [ngClass]="marketing() ? 'bg-primary' : 'bg-gray-300'"
                            />
                            <p class="text-sm font-semibold text-gray-500 break-keep">
                                (선택) 마케팅 수신, 홍보 목적의 개인정보 수집 및 이용에 동의합니다.
                            </p>
                        </div>
                        <lepi-icon
                            (click)="handleDetail(getKeyByValue(termType, termType.PRIVACY))"
                            name="material-symbols:arrow-forward-ios"
                            class="block bg-gray-500 cursor-pointer size-3.5"
                        />
                    </div>
                </div>
            </div>
            <app-button [disabled]="!validForSubmission()" class="max-w-[400px] mb-4 md:mb-0" type="submit" expand>회원가입</app-button>
        </form>
    </div>
</ng-template>
